// assets
import {
  IconHome,
  IconCalendarEvent,
  IconFileInvoice,
  IconChecklist,
  IconUsers,
  IconSoup,
  IconHanger2,
  IconDoor,
  IconUserCircle,
  IconPackage,
  IconCash,
  IconCoinRupee,
  IconReportAnalytics,
  IconBed,
  IconChartBar,
  IconHeadset,
  IconClipboardList,
  IconReceipt2,
  IconAlertCircle,
  IconShirt,
  IconReportMoney,
  IconChevronRight,
  IconChevronDown,
  IconDashboard,
  IconBuildingBank,
  IconTools,
  IconCurrencyDollar,
  IconSettings,
  IconBuildingHospital,
  IconFriends,
  IconBrandWhatsapp,
  IconCategory,
  IconBuildingCommunity,
  IconDiscount2,
  IconApi,
  IconKey
} from '@tabler/icons';

// constant
const icons = {
  IconHome,
  IconCalendarEvent,
  IconFileInvoice,
  IconChecklist,
  IconUsers,
  IconSoup,
  IconHanger2,
  IconDoor,
  IconUserCircle,
  IconPackage,
  IconCash,
  IconCoinRupee,
  IconReportAnalytics,
  IconBed,
  IconChartBar,
  IconHeadset,
  IconClipboardList,
  IconReceipt2,
  IconAlertCircle,
  IconShirt,
  IconReportMoney,
  IconChevronRight,
  IconChevronDown,
  IconDashboard,
  IconBuildingBank,
  IconTools,
  IconCurrencyDollar,
  IconSettings,
  IconBuildingHospital,
  IconFriends,
  IconBrandWhatsapp,
  IconCategory,
  IconBuildingCommunity,
  IconDiscount2,
  IconApi,
  IconKey
};

// ==============================|| ESTILOS PARA EL MENÚ ||============================== //

// Estilos para categorías
const categoryStyles = {
  frontdesk: {
    color: '#2196f3', // Azul
    bgColor: 'rgba(33, 150, 243, 0.08)',
    hoverColor: 'rgba(33, 150, 243, 0.15)'
  },
  housekeeping: {
    color: '#9c27b0', // Púrpura
    bgColor: 'rgba(156, 39, 176, 0.08)',
    hoverColor: 'rgba(156, 39, 176, 0.15)'
  },
  accounting: {
    color: '#4caf50', // Verde
    bgColor: 'rgba(76, 175, 80, 0.08)',
    hoverColor: 'rgba(76, 175, 80, 0.15)'
  },
  restaurant: {
    color: '#ff9800', // Naranja
    bgColor: 'rgba(255, 152, 0, 0.08)',
    hoverColor: 'rgba(255, 152, 0, 0.15)'
  },
  people: {
    color: '#795548', // Marrón
    bgColor: 'rgba(121, 85, 72, 0.08)',
    hoverColor: 'rgba(121, 85, 72, 0.15)'
  },
  reports: {
    color: '#607d8b', // Gris azulado
    bgColor: 'rgba(96, 125, 139, 0.08)',
    hoverColor: 'rgba(96, 125, 139, 0.15)'
  },
  settings: {
    color: '#424242', // Gris oscuro
    bgColor: 'rgba(66, 66, 66, 0.08)',
    hoverColor: 'rgba(66, 66, 66, 0.15)'
  },
  feedback: {
    color: '#e91e63', // Rosa
    bgColor: 'rgba(233, 30, 99, 0.08)',
    hoverColor: 'rgba(233, 30, 99, 0.15)'
  },
  apis: {
    color: '#00897b', // Verde azulado (teal)
    bgColor: 'rgba(0, 137, 123, 0.08)',
    hoverColor: 'rgba(0, 137, 123, 0.15)'
  }
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  type: 'group',
  children: [
    // GESTIÓN DE RESERVAS Y HABITACIONES
    {
      id: 'frontdesk-section',
      title: 'GESTIÓN DE RESERVAS',
      type: 'collapse',
      icon: icons.IconCalendarEvent,
      category: 'frontdesk',
      children: [
        {
          id: 'default',
          title: 'Tablero Principal',
          type: 'item',
          url: '/dashboard/app',
          icon: icons.IconDashboard,
          breadcrumbs: false,
          category: 'frontdesk'
        },
        {
          id: 'calendar-rooms',
          title: 'Calendario de Reservas',
          type: 'item',
          url: '/dashboard/calendar',
          icon: IconCalendarEvent
        },

        {
          id: 'preReservations',
          title: 'Pre-Reservas',
          type: 'item',
          url: '/dashboard/pre-reservations',
          icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: 'whatsappConversations',
          title: 'Conversaciones WhatsApp',
          type: 'item',
          url: '/dashboard/conversations',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false
        },
        {
          id: 'reservation',
          title: 'Reservas Confirmadas',
          type: 'item',
          url: '/dashboard/reservation',
          icon: icons.IconCalendarEvent,
          breadcrumbs: false,
          category: 'frontdesk',
          badge: {
            color: 'warning'
          }
        },
        {
          id: 'tasks',
          title: 'Centro de Tareas',
          type: 'item',
          url: '/dashboard/tasks',
          icon: icons.IconChecklist,
          breadcrumbs: false,
          category: 'frontdesk'
        }
      ]
    },

    // OPERACIONES HOTELERAS
    {
      id: 'housekeeping-section',
      title: 'OPERACIONES HOTELERAS',
      type: 'collapse',
      icon: icons.IconTools,
      category: 'housekeeping',
      children: [
        {
          id: 'housekeeping',
          title: 'Control de Limpieza',
          type: 'item',
          url: '/housekeeping',
          icon: icons.IconTools,
          breadcrumbs: false,
          category: 'housekeeping'
        },
        {
          id: 'laundry',
          title: 'Gestión de Lavandería',
          type: 'item',
          url: '/dashboard/laundary',
          icon: icons.IconShirt,
          breadcrumbs: false,
          category: 'housekeeping'
        },
        {
          id: 'maintenance',
          title: 'Mantenimiento',
          type: 'collapse',
          icon: icons.IconTools,
          category: 'housekeeping',
          children: [
            {
              id: 'maintenance-orders',
              title: 'Órdenes de Trabajo',
              type: 'item',
              url: '/dashboard/maintenance',
              icon: icons.IconClipboardList,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-reports',
              title: 'Reportes y KPIs',
              type: 'item',
              url: '/dashboard/maintenance/reports',
              icon: icons.IconReportAnalytics,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-preventive',
              title: 'Preventivo',
              type: 'item',
              url: '/dashboard/maintenance/preventive',
              icon: icons.IconCalendarEvent,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-assets',
              title: 'Activos',
              type: 'item',
              url: '/dashboard/maintenance/assets',
              icon: icons.IconCategory,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-templates',
              title: 'Plantillas',
              type: 'item',
              url: '/dashboard/maintenance/templates',
              icon: icons.IconChecklist,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-common-areas',
              title: 'Áreas Comunes',
              type: 'item',
              url: '/dashboard/maintenance/common-areas',
              icon: icons.IconBuildingCommunity,
              breadcrumbs: false,
              category: 'housekeeping'
            }
          ]
        }
      ]
    },

    // GESTIÓN FINANCIERA
    {
      id: 'accounting-section',
      title: 'GESTIÓN FINANCIERA',
      type: 'collapse',
      icon: icons.IconCash,
      category: 'accounting',
      children: [
        {
          id: 'cash-register',
          title: 'Operaciones de Caja',
          type: 'collapse',
          icon: icons.IconCash,
          category: 'accounting',
          children: [
            {
              id: 'open-cash-register',
              title: 'Apertura de Caja',
              type: 'item',
              url: '/dashboard/cashregister/open',
              icon: icons.IconCash,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'close-cash-register',
              title: 'Cierre de Caja',
              type: 'item',
              url: '/dashboard/cashregister/close',
              icon: icons.IconCash,
              breadcrumbs: false,
              category: 'accounting'
            }
          ]
        },
        {
          id: 'cash-custody',
          title: 'Custodia de Efectivo',
          type: 'item',
          url: '/dashboard/cash-custody',
          icon: icons.IconBuildingBank,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'expense-management',
          title: 'Gestión de Gastos',
          type: 'collapse',
          icon: icons.IconReportMoney,
          category: 'accounting',
          children: [
            {
              id: 'expenses',
              title: 'Registro de Gastos',
              type: 'item',
              url: '/dashboard/expenses',
              icon: icons.IconReportMoney,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'inventory',
              title: 'Control de Inventario',
              type: 'item',
              url: '/dashboard/inventory',
              icon: icons.IconPackage,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'suppliers',
              title: 'Directorio Proveedores',
              type: 'item',
              url: '/dashboard/suppliers',
              icon: icons.IconFriends,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'departments',
              title: 'Centros de Costo',
              type: 'item',
              url: '/dashboard/departments',
              icon: icons.IconBuildingBank,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'expense-categories',
              title: 'Categorías de Gastos',
              type: 'item',
              url: '/dashboard/expense-categories',
              icon: icons.IconCategory,
              breadcrumbs: false,
              category: 'accounting'
            }
          ]
        },
        {
          id: 'invoice',
          title: 'Gestión de Facturas',
          type: 'item',
          url: '/dashboard/invoice',
          icon: icons.IconFileInvoice,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'payments',
          title: 'Pagos de Suscripción',
          type: 'item',
          url: '/dashboard/hotelpayments',
          icon: icons.IconCurrencyDollar,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'exchange-rate',
          title: 'Gestión de Divisas',
          type: 'item',
          url: '/dashboard/exchangerate',
          icon: icons.IconCoinRupee,
          breadcrumbs: false,
          category: 'accounting'
        }
      ]
    },

    // CONTABILIDAD
    {
      id: 'accounting-ledger-section',
      title: 'CONTABILIDAD',
      type: 'collapse',
      icon: icons.IconReportMoney,
      category: 'accounting',
      children: [
        {
          id: 'chart-of-accounts',
          title: 'Plan de Cuentas',
          type: 'item',
          url: '/dashboard/chart-of-accounts',
          icon: icons.IconReportMoney,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'vouchers',
          title: 'Vouchers Contables',
          type: 'item',
          url: '/dashboard/vouchers',
          icon: icons.IconReceipt2,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'accounting-reports',
          title: 'Reportes Contables',
          type: 'item',
          url: '/dashboard/accounting-reports',
          icon: icons.IconReportAnalytics,
          breadcrumbs: false,
          category: 'accounting'
        }
      ]
    },

    // RESTAURANTE Y PUNTO DE VENTA
    {
      id: 'restaurant-section',
      title: 'RESTAURANTE Y PUNTO DE VENTA',
      type: 'collapse',
      icon: icons.IconSoup,
      category: 'restaurant',
      children: [
        {
          id: 'restaurant',
          title: 'Centro de Restaurante',
          type: 'item',
          url: '/dashboard/restaurant',
          icon: icons.IconSoup,
          breadcrumbs: false,
          category: 'restaurant'
        },
        {
          id: 'kot',
          title: 'Órdenes de Cocina (KOT)',
          type: 'item',
          url: '/dashboard/kot',
          icon: icons.IconReceipt2,
          breadcrumbs: false,
          category: 'restaurant'
        },
        {
          id: 'kot-report',
          title: 'Reportes de Cocina',
          type: 'item',
          url: '/dashboard/kotreports',
          icon: icons.IconClipboardList,
          breadcrumbs: false,
          category: 'restaurant'
        }
      ]
    },

    // GESTIÓN DE CLIENTES Y PERSONAL
    {
      id: 'people-section',
      title: 'CLIENTES Y PERSONAL',
      type: 'collapse',
      icon: icons.IconUsers,
      category: 'people',
      children: [
        {
          id: 'customers',
          title: 'Base de Clientes',
          type: 'item',
          url: '/dashboard/customers',
          icon: icons.IconUserCircle,
          breadcrumbs: false,
          category: 'people'
        },
        {
          id: 'staff-management',
          title: 'Administración de Personal',
          type: 'item',
          url: '/dashboard/staffmanagement',
          icon: icons.IconUsers,
          breadcrumbs: false,
          category: 'people'
        }
      ]
    },

    // REPORTES Y ANÁLISIS
    {
      id: 'reports-section',
      title: 'REPORTES Y ANÁLISIS',
      type: 'collapse',
      icon: icons.IconReportAnalytics,
      category: 'reports',
      children: [
        {
          id: 'cash-register-report',
          title: 'Historial de Cajas',
          type: 'item',
          url: '/cashregister-report',
          icon: icons.IconReportAnalytics,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'whatsapp-metrics',
          title: 'Métricas del Bot WhatsApp',
          type: 'item',
          url: '/dashboard/whatsapp-metrics',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'daily-sales-report',
          title: 'Reporte de Ventas Diarias',
          type: 'item',
          url: '/dashboard/reports',
          icon: icons.IconChartBar,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'general-report',
          title: 'Análisis Financiero General',
          type: 'item',
          url: '/dashboard/generalreport',
          icon: icons.IconClipboardList,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'police-report',
          title: 'Registro de Huéspedes',
          type: 'item',
          url: '/dashboard/policyreports',
          icon: icons.IconChecklist,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'restaurant-report',
          title: 'Reporte de Restaurante',
          type: 'item',
          url: '/dashboard/executive',
          icon: icons.IconSoup,
          breadcrumbs: false,
          category: 'reports'
        }
      ]
    },

    // CONFIGURACIÓN DEL SISTEMA
    {
      id: 'settings-section',
      title: 'CONFIGURACIÓN DEL SISTEMA',
      type: 'collapse',
      icon: icons.IconSettings,
      category: 'settings',
      children: [
        {
          id: 'subscriptions',
          title: 'Planes de Suscripción',
          type: 'item',
          url: '/dashboard/hotelsubscriptions',
          icon: icons.IconPackage,
          breadcrumbs: false,
          category: 'settings'
        },
        {
          id: 'whatsapp-config',
          title: 'Configuración WhatsApp',
          type: 'item',
          url: '/dashboard/whatsapp-config',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false,
          category: 'settings'
        },
        {
          id: 'integrations-sego',
          title: 'Conectar Sego (Restaurante)',
          type: 'item',
          url: '/dashboard/integrations/sego',
          icon: icons.IconBuildingCommunity,
          breadcrumbs: false,
          category: 'settings'
        },
        {
          id: 'room-settings-group',
          title: 'Configuración de Habitaciones',
          type: 'collapse',
          icon: icons.IconBed,
          category: 'settings',
          children: [
            {
              id: 'room-management',
              title: 'Gestión de Habitaciones',
              type: 'item',
              url: '/dashboard/roommanagement',
              icon: icons.IconBed,
              breadcrumbs: false,
              category: 'settings'
            },
            {
              id: 'room-types',
              title: 'Tipos de Habitación',
              type: 'item',
              url: '/dashboard/settings/room-types',
              icon: icons.IconCategory,
              breadcrumbs: false,
              category: 'settings'
            },
            {
              id: 'stay-types',
              title: 'Tipos de Estancia',
              type: 'item',
              url: '/dashboard/settings/stay-types',
              icon: icons.IconList,
              breadcrumbs: false,
              category: 'settings'
            },
            {
              id: 'rates',
              title: 'Tarifas y Precios',
              type: 'item',
              url: '/dashboard/settings/rates',
              icon: icons.IconCurrencyDollar,
              breadcrumbs: false,
              category: 'settings'
            }
          ]
        },
        {
          id: 'hotel-profile',
          title: 'Configuración del Hotel',
          type: 'item',
          category: 'settings'
        }
      ]
    },

    // SOPORTE TÉCNICO
    {
      id: 'feedback-section',
      title: 'SOPORTE TÉCNICO',
      type: 'collapse',
      icon: icons.IconHeadset,
      category: 'feedback',
      children: [
        {
          id: 'complaint',
          title: 'Reportar Problemas',
          type: 'item',
          url: '/dashboard/complaint',
          icon: icons.IconAlertCircle,
          breadcrumbs: false,
          category: 'feedback',
          badge: {
            text: '2',
            color: 'error'
          }
        }
      ]
    }
  ]
};

// ==============================|| Hotel Admin DASHBOARD MENU ITEMS ||============================== //

const hoteladmindashboard = {
  type: 'group',
  children: [
    // GESTIÓN DE RESERVAS Y HABITACIONES
    {
      id: 'frontdesk-section',
      title: 'GESTIÓN DE RESERVAS',
      type: 'collapse',
      icon: icons.IconCalendarEvent,
      category: 'frontdesk',
      children: [
        {
          id: 'default',
          title: 'Tablero Principal',
          type: 'item',
          url: '/dashboard/app',
          icon: icons.IconDashboard,
          breadcrumbs: false,
          category: 'frontdesk'
        },
        {
          id: 'calendar-rooms',
          title: 'Calendario de Reservas',
          type: 'item',
          url: '/dashboard/calendar',
          icon: IconCalendarEvent
        },

        {
          id: 'preReservations',
          title: 'Pre-Reservas',
          type: 'item',
          url: '/dashboard/pre-reservations',
          icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: 'whatsappConversations',
          title: 'Conversaciones WhatsApp',
          type: 'item',
          url: '/dashboard/conversations',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false
        },
        {
          id: 'reservation',
          title: 'Reservas Confirmadas',
          type: 'item',
          url: '/dashboard/reservation',
          icon: icons.IconCalendarEvent,
          breadcrumbs: false,
          category: 'frontdesk',
          badge: {
            color: 'warning'
          }
        },
        {
          id: 'tasks',
          title: 'Centro de Tareas',
          type: 'item',
          url: '/dashboard/tasks',
          icon: icons.IconChecklist,
          breadcrumbs: false,
          category: 'frontdesk'
        }
      ]
    },

    // OPERACIONES HOTELERAS
    {
      id: 'housekeeping-section',
      title: 'OPERACIONES HOTELERAS',
      type: 'collapse',
      icon: icons.IconTools,
      category: 'housekeeping',
      children: [
        {
          id: 'housekeeping',
          title: 'Control de Limpieza',
          type: 'item',
          url: '/housekeeping',
          icon: icons.IconTools,
          breadcrumbs: false,
          category: 'housekeeping'
        },
        {
          id: 'laundry',
          title: 'Gestión de Lavandería',
          type: 'item',
          url: '/dashboard/laundary',
          icon: icons.IconShirt,
          breadcrumbs: false,
          category: 'housekeeping'
        },
        {
          id: 'maintenance',
          title: 'Mantenimiento',
          type: 'collapse',
          icon: icons.IconTools,
          category: 'housekeeping',
          children: [
            {
              id: 'maintenance-orders',
              title: 'Órdenes de Trabajo',
              type: 'item',
              url: '/dashboard/maintenance',
              icon: icons.IconClipboardList,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-reports',
              title: 'Reportes y KPIs',
              type: 'item',
              url: '/dashboard/maintenance/reports',
              icon: icons.IconReportAnalytics,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-preventive',
              title: 'Preventivo',
              type: 'item',
              url: '/dashboard/maintenance/preventive',
              icon: icons.IconCalendarEvent,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-assets',
              title: 'Activos',
              type: 'item',
              url: '/dashboard/maintenance/assets',
              icon: icons.IconCategory,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-templates',
              title: 'Plantillas',
              type: 'item',
              url: '/dashboard/maintenance/templates',
              icon: icons.IconChecklist,
              breadcrumbs: false,
              category: 'housekeeping'
            },
            {
              id: 'maintenance-common-areas',
              title: 'Áreas Comunes',
              type: 'item',
              url: '/dashboard/maintenance/common-areas',
              icon: icons.IconBuildingCommunity,
              breadcrumbs: false,
              category: 'housekeeping'
            }
          ]
        }
      ]
    },

    // GESTIÓN FINANCIERA
    {
      id: 'accounting-section',
      title: 'GESTIÓN FINANCIERA',
      type: 'collapse',
      icon: icons.IconCash,
      category: 'accounting',
      children: [
        {
          id: 'cash-register',
          title: 'Operaciones de Caja',
          type: 'collapse',
          icon: icons.IconCash,
          category: 'accounting',
          children: [
            {
              id: 'open-cash-register',
              title: 'Apertura de Caja',
              type: 'item',
              url: '/dashboard/cashregister/open',
              icon: icons.IconCash,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'close-cash-register',
              title: 'Cierre de Caja',
              type: 'item',
              url: '/dashboard/cashregister/close',
              icon: icons.IconCash,
              breadcrumbs: false,
              category: 'accounting'
            }
          ]
        },
        {
          id: 'cash-custody',
          title: 'Custodia de Efectivo',
          type: 'item',
          url: '/dashboard/cash-custody',
          icon: icons.IconBuildingBank,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'expense-management',
          title: 'Gestión de Gastos',
          type: 'collapse',
          icon: icons.IconReportMoney,
          category: 'accounting',
          children: [
            {
              id: 'expenses',
              title: 'Registro de Gastos',
              type: 'item',
              url: '/dashboard/expenses',
              icon: icons.IconReportMoney,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'inventory',
              title: 'Control de Inventario',
              type: 'item',
              url: '/dashboard/inventory',
              icon: icons.IconPackage,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'suppliers',
              title: 'Directorio Proveedores',
              type: 'item',
              url: '/dashboard/suppliers',
              icon: icons.IconFriends,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'departments',
              title: 'Centros de Costo',
              type: 'item',
              url: '/dashboard/departments',
              icon: icons.IconBuildingBank,
              breadcrumbs: false,
              category: 'accounting'
            },
            {
              id: 'expense-categories',
              title: 'Categorías de Gastos',
              type: 'item',
              url: '/dashboard/expense-categories',
              icon: icons.IconCategory,
              breadcrumbs: false,
              category: 'accounting'
            }
          ]
        },
        {
          id: 'invoice',
          title: 'Gestión de Facturas',
          type: 'item',
          url: '/dashboard/invoice',
          icon: icons.IconFileInvoice,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'payments',
          title: 'Pagos de Suscripción',
          type: 'item',
          url: '/dashboard/hotelpayments',
          icon: icons.IconCurrencyDollar,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'exchange-rate',
          title: 'Gestión de Divisas',
          type: 'item',
          url: '/dashboard/exchangerate',
          icon: icons.IconCoinRupee,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'promo-codes',
          title: 'Códigos Promocionales',
          type: 'item',
          url: '/dashboard/settings/promo-codes',
          icon: icons.IconCategory,
          breadcrumbs: false,
          category: 'accounting'
        }
      ]
    },

    // CONTABILIDAD
    {
      id: 'accounting-ledger-section',
      title: 'CONTABILIDAD',
      type: 'collapse',
      icon: icons.IconReportMoney,
      category: 'accounting',
      children: [
        {
          id: 'chart-of-accounts',
          title: 'Plan de Cuentas',
          type: 'item',
          url: '/dashboard/chart-of-accounts',
          icon: icons.IconReportMoney,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'vouchers',
          title: 'Vouchers Contables',
          type: 'item',
          url: '/dashboard/vouchers',
          icon: icons.IconReceipt2,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'accounting-reports',
          title: 'Reportes Contables',
          type: 'item',
          url: '/dashboard/accounting-reports',
          icon: icons.IconReportAnalytics,
          breadcrumbs: false,
          category: 'accounting'
        }
      ]
    },

    // RESTAURANTE Y PUNTO DE VENTA
    {
      id: 'restaurant-section',
      title: 'RESTAURANTE Y PUNTO DE VENTA',
      type: 'collapse',
      icon: icons.IconSoup,
      category: 'restaurant',
      children: [
        {
          id: 'restaurant',
          title: 'Centro de Restaurante',
          type: 'item',
          url: '/dashboard/restaurant',
          icon: icons.IconSoup,
          breadcrumbs: false,
          category: 'restaurant'
        },
        {
          id: 'kot',
          title: 'Órdenes de Cocina (KOT)',
          type: 'item',
          url: '/dashboard/kot',
          icon: icons.IconReceipt2,
          breadcrumbs: false,
          category: 'restaurant'
        },
        {
          id: 'kot-report',
          title: 'Reportes de Cocina',
          type: 'item',
          url: '/dashboard/kotreports',
          icon: icons.IconClipboardList,
          breadcrumbs: false,
          category: 'restaurant'
        }
      ]
    },

    // GESTIÓN DE CLIENTES Y PERSONAL
    {
      id: 'people-section',
      title: 'CLIENTES Y PERSONAL',
      type: 'collapse',
      icon: icons.IconUsers,
      category: 'people',
      children: [
        {
          id: 'customers',
          title: 'Base de Clientes',
          type: 'item',
          url: '/dashboard/customers',
          icon: icons.IconUserCircle,
          breadcrumbs: false,
          category: 'people'
        },
        {
          id: 'staff-management',
          title: 'Administración de Personal',
          type: 'item',
          url: '/dashboard/staffmanagement',
          icon: icons.IconUsers,
          breadcrumbs: false,
          category: 'people'
        }
      ]
    },

    // REPORTES Y ANÁLISIS
    {
      id: 'reports-section',
      title: 'REPORTES Y ANÁLISIS',
      type: 'collapse',
      icon: icons.IconReportAnalytics,
      category: 'reports',
      children: [
        {
          id: 'cash-register-report',
          title: 'Historial de Cajas',
          type: 'item',
          url: '/cashregister-report',
          icon: icons.IconReportAnalytics,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'whatsapp-metrics',
          title: 'Métricas del Bot WhatsApp',
          type: 'item',
          url: '/dashboard/whatsapp-metrics',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'daily-sales-report',
          title: 'Reporte de Ventas Diarias',
          type: 'item',
          url: '/dashboard/reports',
          icon: icons.IconChartBar,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'general-report',
          title: 'Análisis Financiero General',
          type: 'item',
          url: '/dashboard/generalreport',
          icon: icons.IconClipboardList,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'police-report',
          title: 'Registro de Huéspedes',
          type: 'item',
          url: '/dashboard/policyreports',
          icon: icons.IconChecklist,
          breadcrumbs: false,
          category: 'reports'
        },
        {
          id: 'restaurant-report',
          title: 'Reporte de Restaurante',
          type: 'item',
          url: '/dashboard/executive',
          icon: icons.IconSoup,
          breadcrumbs: false,
          category: 'reports'
        }
      ]
    },

    // CONFIGURACIÓN DEL SISTEMA
    {
      id: 'settings-section',
      title: 'CONFIGURACIÓN DEL SISTEMA',
      type: 'collapse',
      icon: icons.IconSettings,
      category: 'settings',
      children: [
        {
          id: 'subscriptions',
          title: 'Planes de Suscripción',
          type: 'item',
          url: '/dashboard/hotelsubscriptions',
          icon: icons.IconPackage,
          breadcrumbs: false,
          category: 'settings'
        },
        {
          id: 'whatsapp-config',
          title: 'Configuración WhatsApp',
          type: 'item',
          url: '/dashboard/whatsappconfig',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false,
          category: 'settings'
        },
        {
          id: 'room-settings-group',
          title: 'Configuración de Habitaciones',
          type: 'collapse',
          icon: icons.IconBed,
          category: 'settings',
          children: [
            {
              id: 'room-management',
              title: 'Gestión de Habitaciones',
              type: 'item',
              url: '/dashboard/roommanagement',
              icon: icons.IconBed,
              breadcrumbs: false,
              category: 'settings'
            },
            {
              id: 'room-types',
              title: 'Tipos de Habitación',
              type: 'item',
              url: '/dashboard/settings/room-types',
              icon: icons.IconCategory,
              breadcrumbs: false,
              category: 'settings'
            },
            {
              id: 'stay-types',
              title: 'Tipos de Estancia',
              type: 'item',
              url: '/dashboard/settings/stay-types',
              icon: icons.IconList,
              breadcrumbs: false,
              category: 'settings'
            },
            {
              id: 'rates',
              title: 'Tarifas y Precios',
              type: 'item',
              url: '/dashboard/settings/rates',
              icon: icons.IconCurrencyDollar,
              breadcrumbs: false,
              category: 'settings'
            }
          ]
        },
        {
          id: 'hotel-profile',
          title: 'Configuración del Hotel',
          type: 'item',
          url: '/dashboard/profile',
          icon: icons.IconBuildingBank,
          breadcrumbs: false,
          category: 'settings'
        }
      ]
    },

    // SOPORTE TÉCNICO
    {
      id: 'feedback-section',
      title: 'SOPORTE TÉCNICO',
      type: 'collapse',
      icon: icons.IconHeadset,
      category: 'feedback',
      children: [
        {
          id: 'complaint',
          title: 'Reportar Problemas',
          type: 'item',
          url: '/dashboard/complaint',
          icon: icons.IconAlertCircle,
          breadcrumbs: false,
          category: 'feedback',
          badge: {
            text: '2',
            color: 'error'
          }
        }
      ]
    }
  ]
};

// ==============================|| ADMIN DASHBOARD MENU ITEMS ||============================== //
const admindashboard = {
  type: 'group',
  children: [
    // Dashboard principal
    {
      id: 'main-section',
      title: 'ADMINISTRACIÓN PRINCIPAL',
      type: 'collapse',
      icon: icons.IconDashboard,
      category: 'frontdesk',
      children: [
        {
          id: 'default',
          title: 'Panel de Administración',
          type: 'item',
          url: '/dashboard/admindashboard',
          icon: icons.IconDashboard,
          breadcrumbs: false,
          category: 'frontdesk'
        },
        {
          id: 'segoia-conversations',
          title: 'Conversaciones Sego IA',
          type: 'item',
          url: '/dashboard/admin-sego-ia-dialogues',
          icon: icons.IconMessageCircle,
          breadcrumbs: false,
          category: 'frontdesk'
        }
      ]
    },

    // Gestión de hoteles
    {
      id: 'hotels-section',
      title: 'GESTIÓN DE HOTELES',
      type: 'collapse',
      icon: icons.IconBuildingBank,
      category: 'people',
      children: [
        {
          id: 'hotel-management',
          title: 'Administración de Hoteles',
          type: 'item',
          url: '/dashboard/hotel',
          icon: icons.IconBuildingBank,
          breadcrumbs: false,
          category: 'people',
          badge: {
            text: '3',
            color: 'success'
          }
        }
      ]
    },

    // Finanzas
    {
      id: 'finance-section',
      title: 'GESTIÓN FINANCIERA GLOBAL',
      type: 'collapse',
      icon: icons.IconCurrencyDollar,
      category: 'accounting',
      children: [
        {
          id: 'packages',
          title: 'Gestión de Paquetes',
          type: 'item',
          url: '/dashboard/subscriptions',
          icon: icons.IconPackage,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'payments',
          title: 'Pagos Globales',
          type: 'item',
          url: '/dashboard/payments',
          icon: icons.IconCurrencyDollar,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'payment-gateways',
          title: 'Pasarelas de Pago',
          type: 'item',
          url: '/dashboard/payment-gateways',
          icon: icons.IconBuildingBank,
          breadcrumbs: false,
          category: 'accounting'
        },
        {
          id: 'platform-promo-codes',
          title: 'Códigos Promocionales',
          type: 'item',
          url: '/dashboard/promo-codes',
          icon: icons.IconDiscount2,
          breadcrumbs: false,
          category: 'accounting'
        }
      ]
    },

    // Soporte
    {
      id: 'support-section',
      title: 'SOPORTE GLOBAL',
      type: 'collapse',
      icon: icons.IconHeadset,
      category: 'feedback',
      children: [
        {
          id: 'support',
          title: 'Centro de Soporte',
          type: 'item',
          url: '/dashboard/admincomplaint',
          icon: icons.IconHeadset,
          breadcrumbs: false,
          category: 'feedback',
          badge: {
            text: '2',
            color: 'error'
          }
        },
        {
          id: 'global-ia',
          title: 'Configuración Sego IA',
          type: 'item',
          url: '/dashboard/admin-sego-ia',
          icon: icons.IconBrandWhatsapp,
          breadcrumbs: false,
          category: 'feedback'
        }
      ]
    },

    // Reportes
    {
      id: 'reports-section',
      title: 'REPORTES GLOBALES',
      type: 'collapse',
      icon: icons.IconReportAnalytics,
      category: 'reports',
      children: [
        {
          id: 'reports',
          title: 'Análisis y Reportes',
          type: 'item',
          url: '/dashboard/adminreports',
          icon: icons.IconReportAnalytics,
          breadcrumbs: false,
          category: 'reports'
        }
      ]
    },

    // APIs de hoteles (solo lectura)
    {
      id: 'apis-section',
      title: 'GESTIÓN DE APIS',
      type: 'collapse',
      icon: icons.IconApi,
      category: 'apis',
      children: [
        {
          id: 'hotel-api-keys',
          title: 'APIs de Hoteles',
          type: 'item',
          url: '/dashboard/api-keys',
          icon: icons.IconKey,
          breadcrumbs: false,
          category: 'apis'
        }
      ]
    }
  ]
};

export { dashboard, hoteladmindashboard, admindashboard, categoryStyles };
